<div class="mobile-categories" [mmTestId]="'ALL_PAGES.HEADER_CATEGORIES_MOBILE'">
  <div>
    <app-price-switch
      [mobileMenuShown]="mobileMenuShown"
      [inCategoriesMenu]="true"
      [inputId]="'price-switch-input-mobile-categories'"
    >
    </app-price-switch>
  </div>
  <div *ngIf="isTopCategoryView">
    <app-header-buy-again (onClick)="closeMenu()"> </app-header-buy-again>
  </div>

  <div class="mobile-categories-header" *ngIf="!isTopCategoryView" [mmTestTarget]="'mobile-categories-back-button'">
    <div class="back" (click)="backToTopCategories()" *ngIf="selectedCategory?.id !== promoCategoriesId">
      <mm-icon name="arrow-left"></mm-icon>
      <span>{{ 'CHECKOUT.STEPPER.BACK' | translate }}</span>
    </div>
    <div class="back-promo" (click)="backToTopCategories()" *ngIf="selectedCategory?.id === promoCategoriesId">
      <mm-icon name="arrow-left"></mm-icon>
      <span>{{ selectedCategory?.name }}</span>
    </div>
    <app-promo-image-link
      *ngIf="selectedCategory?.id === promoCategoriesId"
      (menuClosed)="closeMenu()"
    ></app-promo-image-link>
    <div
      *ngIf="selectedCategory?.id !== promoCategoriesId"
      class="category nested-categories__show-parent--all-promo"
      (click)="onCategorySelect(selectedCategory, 'HEADER.NESTED_CATEGORIES.SHOW')"
    >
      {{ 'HEADER.NESTED_CATEGORIES.SHOW' | translate }} {{ selectedCategory?.name }}
    </div>
    <div class="category nested-categories__show-parent--all-promo" *ngIf="selectedCategory?.id === promoCategoriesId">
      {{ 'HOME.HOME_PAGE.PROMO_TITLE' | translate }}
    </div>
  </div>

  <ul [@categoryListAnimation]="isTopCategoryView" class="mobile-categories-list">
    <a
      *ngIf="selectedCategory?.id === promoCategoriesId"
      [routerLink]="allOffersRoute"
      class="category-item"
      fxLayoutAlign="flex-start center"
      (click)="fireAllPromotionsClickEvent(selectedCategory?.name, 'HEADER.NESTED_CATEGORIES.SHOW')"
    >
      <ng-container>
        {{ 'HOME.HOME_PAGE.HEADER.CATEGORIES.ALL_OFFERS' | translate }}
      </ng-container>
      <mm-icon name="chevron-right" class="category-item__arrow"> </mm-icon>
    </a>

    <ng-container *ngFor="let category of displayCategories; let i = index">
      <li
        class="mobile-categories-list__item"
        *ngIf="selectedCategory?.id !== promoCategoriesId || i < maxPromoMenuItems"
      >
        <app-category-item [category]="category" (categorySelected)="onCategorySelect($event)"></app-category-item>
      </li>
    </ng-container>
  </ul>

  <app-editorial-link-list
    *ngIf="selectedCategory?.id === promoCategoriesId && editorialList"
    [isMobile]="true"
    [editorialList]="editorialList"
    (menuClosed)="closeMenu()"
  ></app-editorial-link-list>
  <app-menu-navigation-banner
    *ngIf="selectedCategory?.id === promoCategoriesId && thematicResources"
    [isMobile]="true"
    [thematicResources]="thematicResources"
    (menuClosed)="closeMenu()"
  ></app-menu-navigation-banner>
</div>
